module.exports = __webpack_public_path__ + "img/hone-content-titel.12c31e06.png";